/*
 * @Author: xhh
 * @Date: 2021-05-26 08:51:24
 * @LastEditTime: 2021-09-17 08:55:33
 * @LastEditors: Please set LastEditors
 * @Description: 混入
 * @FilePath: \2.0\src\mixins\index.js
 */
export default {
  data: function data() {
    return {
      PROJECT_OBJ: {
        PROJECT_NAME: '飞信'
      }
    };
  }
};